import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1a08626"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "fill-current",
  style: {"width":"1rem"},
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown relative border-2 shadow-md bg-white border-primary-500 text-gray-800 dark:bg-dark-200 dark:border-dark-200 dark:text-dark-text",
    style: {"border-radius":"1rem"},
    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nested.hide.value = true)),
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nested.hide.value = false))
  }, [
    _createElementVNode("button", {
      class: "px-1 py-1 items-center focus:outline-none text-xl flex",
      style: _normalizeStyle({ width: _ctx.width })
    }, [
      _createElementVNode("span", {
        class: _normalizeClass('text-base whitespace-nowrap'),
        style: _normalizeStyle({ width: _ctx.textWidth })
      }, _toDisplayString(_ctx.itemList[_ctx.selectedIndex]), 5),
      (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
    ], 4),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("ul", {
          class: "dropdown-menu absolute hidden shadow-xl z-10",
          style: _normalizeStyle([{"top":"2.1rem","border-radius":"1rem"}, { width: '7rem' }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (value, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "rounded",
              style: { width: '7rem' }
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["py-1 px-3 text-base w-full block whitespace-no-wrap text-left focus:outline-none border-l border-r bg-white hover:bg-primary-50 text-gray-800 dark:bg-dark-200 dark:text-dark-text dark:hover:bg-dark-10 dark:border-dark-200", {
              'list-round-first border-t': index == 0,
              'list-round-last border-b': index == _ctx.itemList.length - 1
            }]),
                onClick: ($event: any) => (_ctx.click(index))
              }, _toDisplayString(value), 11, _hoisted_4)
            ]))
          }), 128))
        ], 512), [
          [_vShow, !_ctx.nested.hide.value]
        ])
      ]),
      _: 1
    })
  ], 32))
}